// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2msZ0","description":"PatientConsentPreview_description__3PRiz"};